"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeSlice = exports.sessionSlice = exports.setAdditionalDefaultHeaders = exports.getBrowserDefaultLanguage = exports.LOCALE_LANG_KEY = exports.SESSION_KEY = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const flax_1 = require("@coralblack/flax");
const common_1 = require("../../consts/common");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const log = (...args) => (process.env.REACT_APP_STAGE === "shared" || process.env.REACT_APP_STAGE === "local" || process.env.REACT_APP_STAGE === "develop") &&
    // eslint-disable-next-line no-console
    console.log(...args);
// Set baseUrl
(0, flax_1.setBaseUrl)(process.env.REACT_APP_CDMS_URL || process.env.REACT_APP_CDMS_BE_URL || process.env.REACT_APP_SERVICE_HOST || "http://127.0.0.1");
exports.SESSION_KEY = "cream:auth";
exports.LOCALE_LANG_KEY = "LoLang";
const stored = localStorage.getItem(exports.SESSION_KEY);
const getBrowserDefaultLanguage = () => {
    switch (navigator.language.toLocaleLowerCase()) {
        case "ko":
        case "ko-kr":
            return common_1.LoLang.KO;
        case "fr":
        case "fr-fr":
            return common_1.LoLang.FR;
        case "nl":
        case "nl-nl":
            return common_1.LoLang.NL;
        default:
            return common_1.LoLang.EN;
    }
};
exports.getBrowserDefaultLanguage = getBrowserDefaultLanguage;
if (!localStorage.getItem(exports.LOCALE_LANG_KEY)) {
    localStorage.setItem(exports.LOCALE_LANG_KEY, (0, exports.getBrowserDefaultLanguage)());
}
const language = localStorage.getItem(exports.LOCALE_LANG_KEY);
const initialState = Object.assign({
    token: null,
    expiryAt: null,
}, stored ? JSON.parse(stored) : {});
const localeInitialState = Object.assign({ lolang: common_1.LoLang.KO }, language ? { lolang: language } : {});
(_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.setAttribute("lang", String(localeInitialState.lolang).toLowerCase());
const configurableDefaultHeaders = (headers) => Object.assign({
    Authorization: initialState.token,
    Lang: language || common_1.LoLang.KO,
    "Timezone-Offset": -new Date().getTimezoneOffset(),
}, headers || {});
(0, flax_1.setDefaultHeaders)(configurableDefaultHeaders());
const setAdditionalDefaultHeaders = (headers) => (0, flax_1.setDefaultHeaders)(headers);
exports.setAdditionalDefaultHeaders = setAdditionalDefaultHeaders;
exports.sessionSlice = (0, toolkit_1.createSlice)({
    name: "session",
    initialState,
    reducers: {
        signIn(state, action) {
            state.token = action.payload.authToken.token;
            state.expiryAt = action.payload.authToken.expiryAt;
            localStorage.setItem(exports.SESSION_KEY, JSON.stringify({ ...state, redirectTo: undefined }));
            if (action.payload.redirectTo) {
                if (action.payload.redirectTo.includes(":")) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const [_, restProtocol] = action.payload.redirectTo.split(":");
                    const [hostname] = (restProtocol || "").slice(2).split("/");
                    const domain = String((hostname || "").split(".").slice(-2)[0]).toLowerCase(); // TLD는 1차(.com, .dev, .io, ..)만으로 간주함
                    if (!["mavencdms", "mavenclinical"]
                        .concat(["local", "shared"].includes(process.env.REACT_APP_STAGE) ? ["localhost", "127.0.0.1"] : [])
                        .includes(domain)) {
                        log(`sessionSlice:signIn, Redirection Host Not Allowed, (${domain})`);
                        document.location.href = "/";
                        return;
                    }
                }
                log(`sessionSlice:signIn, Redirect to (${action.payload.redirectTo})`);
                document.location.href = action.payload.redirectTo;
            }
            else {
                log("sessionSlice:signIn, Reload.");
                document.location.reload();
            }
        },
        signOut(state) {
            state.token = null;
            state.expiryAt = null;
            localStorage.removeItem(exports.SESSION_KEY);
            document.location.href = "/";
        },
        refreshSignIn(state, action) {
            state.token = action.payload.authToken.token;
            state.expiryAt = action.payload.authToken.expiryAt;
            localStorage.setItem(exports.SESSION_KEY, JSON.stringify({ ...state, redirectTo: undefined }));
            (0, flax_1.setDefaultHeaders)(configurableDefaultHeaders({ Authorization: action.payload.authToken.token }));
        },
        updateExpiryAt(state, action) {
            state.expiryAt = action.payload.authToken.expiryAt;
            localStorage.setItem(exports.SESSION_KEY, JSON.stringify({ ...state, redirectTo: undefined }));
        },
    },
});
exports.localeSlice = (0, toolkit_1.createSlice)({
    name: "locale",
    initialState: localeInitialState,
    reducers: {
        changeLocaleLanguage(state, action) {
            var _a;
            state.lolang = action.payload.lolang;
            localStorage.setItem(exports.LOCALE_LANG_KEY, state.lolang);
            (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.setAttribute("lang", String(state.lolang).toLowerCase());
        },
    },
});
//# sourceMappingURL=session.js.map